import { readCookie, createCookie } from '../../components/common/Cookie';
import getMobileOperatingSystem from './DetectDeviceType';
import {
  HEADER_VISIBILITY_TYPE_ANDROID,
  HEADER_VISIBILITY_TYPE_IOS,
  LOCATION_TYPE,
  GET_AUTHENTICATION_TOKEN_TYPE,
  CLOSE_SCREEN,
  HANDLE_WEBVIEW_BACK,
  GET_SESSION_DETAILS,
  SAVE_SESSION_DETAILS,
  REFRESH_AUTHENTICATION_TOKEN
} from '../constants/myJio.constants';
import { signInCheck } from '../../components/common/CheckUserStatus';
import { gtmEventPushPLP } from '../../modules/ga/GTMdatalayer';

const device = getMobileOperatingSystem();
const isIOS = device === 'iOS';
const headerVisibilityType = isIOS ? HEADER_VISIBILITY_TYPE_IOS : HEADER_VISIBILITY_TYPE_ANDROID;

const sendToApp = payload => {
  if (window) {
    console.log('SEND TO APP FUNCTION CALLED ....................', payload);
    const encodedData = window.btoa(JSON.stringify(payload));
    if (window.android && window.android?.__externalCall)
      window.android?.__externalCall(encodedData);
    if (window.__externalCall) window.__externalCall(encodedData);
    if (isIOS && window.webkit?.messageHandlers && window.webkit?.messageHandlers?.callback)
      window.webkit?.messageHandlers?.callback?.postMessage(encodedData);
  }
};

export const checkMyJioRedirection = (): boolean => {
  const isMyJioRedirection = readCookie('isMyJioRedirection') || 'false';
  if (isMyJioRedirection === 'true') return true;
  return false;
};

export const showHeader = () => {
  const myJioHeaderVisibility = readCookie('myJioHeaderVisibility') || null;
  console.log('MYJIO INTEGRATION ~ HEADER SHOW...........', myJioHeaderVisibility);
  if (myJioHeaderVisibility !== '2') {
    sendToApp({ type: headerVisibilityType, value: 2 });
    createCookie('myJioHeaderVisibility', '2', 30);
  }
};

export const hideHeader = () => {
  const myJioHeaderVisibility = readCookie('myJioHeaderVisibility') || null;
  console.log('MYJIO INTEGRATION ~ HEADER HIDE...........', myJioHeaderVisibility);
  if (myJioHeaderVisibility !== '0') {
    sendToApp({ type: headerVisibilityType, value: 0 });
    createCookie('myJioHeaderVisibility', '0', 30);
  }
};

export const getLocationData = () => {
  console.log('MYJIO INTEGRATION ~ LOCATION .....................');
  sendToApp({ type: LOCATION_TYPE });
};

export const getMyJioToken = () => {
  console.log('MYJIO INTEGRATION ~ GET ACCESS TOKEN .....................');
  sendToApp({ type: GET_AUTHENTICATION_TOKEN_TYPE });
};

export const closeScreen = () => {
  sendToApp({ type: CLOSE_SCREEN });
};

export const handleWebviewBackButton = () => {
  if (!isIOS) {
    sendToApp({ type: HANDLE_WEBVIEW_BACK, value: true });
  }
};

export function checkMyJioSignIn() {
  const userName = signInCheck(true);
  const isSignedIn = userName?.length > 0 || false;
  return isSignedIn;
}

export const getSessionDetails = () => {
  console.log('MYJIO INTEGRATION ~ GET SESSIOM DETAILS .....................');
  sendToApp({ type: GET_SESSION_DETAILS, value: { microAppID: '30001' } });
};

export const saveSessionDetails = sessionDetails => {
  console.log('MYJIO INTEGRATION ~ SAVE SESSION DETAILS .....................');
  sendToApp({ type: SAVE_SESSION_DETAILS, value: sessionDetails });
};

export const refreshAuthenticationToken = () => {
  console.log('MYJIO INTEGRATION ~ REFRESH AUTH TOKEN .....................');
  sendToApp({ type: REFRESH_AUTHENTICATION_TOKEN });
};

export const closeScreenOnMyJioAction = () => {
  gtmEventPushPLP({
    event: 'plp_navigation_interaction',
    event_category: 'plp_interaction',
    event_action: 'back click',
    event_label: 'back',
    store_type: 'ajio',
    page_type: window.pageType || ''
  }, 'plp_navigation_interaction', true);
  const urlParams = new URLSearchParams(window.location.search);
  const isMyJioSource = urlParams.get('source');
  const actionScreen = urlParams.get('myJioAction');
  console.log('TRACK MY JIO TRACK ADDITIONAL PARAMETERS ~ isMyJioSource:', isMyJioSource);
  console.log('TRACK MY JIO TRACK ADDITIONAL PARAMETERS ~ actionScreen:', actionScreen);
  if (isMyJioSource?.toLowerCase() === 'myjio' && actionScreen?.toLowerCase() === 'close') {
    console.log('TRACK MY JIO TRACK ADDITIONAL PARAMETERS ~ SCREEN CLOSE................');
    closeScreen();
  } else {
    const sourcePageReferrer = urlParams.get('referrer');
   
    const { history } = window;
    if (history.length > 1) {
      if(sourcePageReferrer === 'fleek_curated_plp_screen'){
        window.location.href = '/'
      }else {
       window.history.go(-1);
     }
    } else {
      window.location.href = '/'; 
    }
  }
};
